import { Injectable } from '@angular/core';

import { LOCALE } from './locale.constants';

@Injectable({
    providedIn: 'root'
})
export class LocaleService {

    constructor() {}

    /**
     * Creates a locale string from both browser's language and region availaible or as a default
     * @returns string Locale. Eg. 'en-us'
     */
    getLocale(): string {
        return (navigator.languages && navigator.languages.length && navigator.languages[0])
        || navigator.language
        || LOCALE.DEFAULT_LOCALE;
    }

    /**
     * Adds the locale to the url
     * @param serviceUrl - the url to be signed with the locale
     * @param path 
     * @returns url with or without the locale
     */
    getUrlLocale(serviceUrl: string, path: string): string {
        let locale = path && path.match('\/[a-zA-Z]{2}-[a-zA-Z]{2}\/');
        let url = locale && locale[0] ? 
            locale[0].replace(/\//g, '') + serviceUrl :
            serviceUrl;

        return url;
    }

}
